<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;">Informations personnelles </h1>
                    <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> informations personnelles </span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- Start service Area -->
<section class="service-area section-gap" id="service">
    <div class="container mb-5">
        <!-- Taux de remplissage (progress bar) -->

        <div class="row mb-4">
            <div class="col-md-12 ">
                <div class="card"
                    style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);border-radius: 15px;">
                    <div class="card-body">
                        <p>Profil complèté à {{ totalFillingRate }}%</p>
                        <div class="progress">
                            <div [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                                role="progressbar" [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center'}"
                                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-md-4 mb-3" *ngIf="showBtnToGoApplyJob">
            <button routerLink="/postuler/{{ jobIDToApply }}" style="color: white;" class="btn btn-danger">Retour
                vers l'offre</button>
        </div>
        <div class="row mb-5">
            <div class="col-md-9 ">
                <div class="card"
                    style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); padding: 50px;">
                    <div class="card-body">
                        <!-- <h3 class="mt-3 mb-5" style="text-align: center; font-weight: bold;">Informations
                            personnelles
                        </h3> -->
                        <form [formGroup]="personalInfoForm" (ngSubmit)="onSubmitPersonalInfoForm()">
                            <div style="margin-top: -5px; margin-bottom: 10px; color: red;">
                                Cliquer sur le bouton <strong>"SAUVEGARDER"</strong> après avoir
                                effectuée des
                                modifications sur le formulaire.
                            </div>
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="gender">Sexe <span class="star-style">**</span></label>
                                    <select class="form-control" id="gender" formControlName="gender">
                                        <option value="Homme">Homme</option>
                                        <option value="Femme">Femme</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="maritalStatus">Situation matrimoniale</label>
                                    <select class="form-control" id="maritalStatus" formControlName="maritalStatus">
                                        <option value="célibataire">Célibataire</option>
                                        <option value="Marié(e) avec enfant">Marié(e) avec enfants</option>
                                        <option value="Marié(e) sans enfant">Marié(e) sans enfants</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="lastName">Nom <span class="star-style">**</span></label>
                                    <input type="text" class="form-control h-40px" id="lastName"
                                        formControlName="lastName">
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="firstName">Prénom <span class="star-style">**</span></label>
                                    <input type="text" class="form-control h-40px" id="firstName"
                                        formControlName="firstName">
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="dateBirth">Date de naissance <span class="star-style">**</span></label>
                                    <input type="date" class="form-control h-40px" id="dateBirth"
                                        formControlName="dateBirth">
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="email">Email <span class="star-style">**</span></label>
                                    <input type="hidden" class="form-control h-40px" formControlName="email">
                                    <input type="email" class="form-control h-40px" id="email"
                                        [value]="candidates.getEmail()" disabled>
                                </div>

                                <div class="form-group col-md-4"
                                    [ngClass]="idcardValue == null ? 'form-group col-md-6' : 'form-group col-md-4'">
                                    <label for="idcard">CNI/Passport<span
                                            style="font-size: 10px; font-weight: 700;">(pdf, < 1Mo)</span>
                                                <span class="star-style">**</span></label>
                                    <span class="btn btn-success w-100" *ngIf="idcardValue == null"
                                        (click)="chooseNewIdcard()">Joindre
                                        CNI/passport</span>
                                    <span class="btn btn-primary w-100" *ngIf="idcardValue != null"
                                        (click)="chooseNewIdcard()">Remplacer
                                        CNI/passport</span>
                                    <span *ngIf="idcardFile != null"
                                        style="font-size: 10px; font-weight: 700; color: green">
                                        Super!
                                        Fichier
                                        joint</span>
                                </div>
                                <div class="form-group col-md-4 my-auto pt-3">
                                    <a [href]="idCard" target="_blank" class="btn btn-danger w-100"
                                        *ngIf="idcardValue !== null">Afficher
                                        CNI/passport</a>
                                </div>

                                <div class="form-group col-md-4"
                                    [ngClass]="cvValue == null ? 'form-group col-md-6' : 'form-group col-md-4'">
                                    <label for="curriculumVitae">Curriculum vitae <span
                                            style="font-size: 10px; font-weight: 700;">(pdf,
                                            < 1Mo)</span> <span class="star-style">**</span></label>
                                    <span class="btn btn-success w-100" *ngIf="cvValue == null"
                                        (click)="chooseNewCV()">Joindre
                                        curriculum
                                        vitae</span>
                                    <span class="btn btn-primary w-100" *ngIf="cvValue != null"
                                        (click)="chooseNewCV()">Remplacer
                                        CV</span>
                                    <span *ngIf="cvFile != null"
                                        style="font-size: 10px; font-weight: 700; color: green">
                                        Super!
                                        Fichier
                                        joint</span>
                                </div>
                                <div class="form-group col-md-4 my-auto pt-3">
                                    <a [href]="cvPath" target="_blank" class="btn btn-danger w-100"
                                        *ngIf="cvValue != null">Afficher
                                        CV</a>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="phone1">Téléphone 1 <span class="star-style">**</span></label>
                                    <input type="text" class="form-control h-40px" id="phone1" formControlName="phone1">
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="phone2">Téléphone 2</label>
                                    <input type="text" class="form-control h-40px" id="phone2" formControlName="phone2">
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="country">Pays</label>
                                    <select class="form-control" id="country" formControlName="country"
                                        (ngModelChange)="onChangeCountry($event)">
                                        <option [value]="country" *ngFor="let country of countryList">{{ country
                                            }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="city">Ville</label>
                                    <select class="form-control" id="city" formControlName="city">
                                        <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="tempWorker">Emploi recherché: <span class="star-style"></span></label>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="Emploi"
                                            id="flexCheckDefault" (change)="onCheckboxProfilChange($event)">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            Emploi
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="Intérim"
                                            id="flexCheckChecked" (change)="onCheckboxProfilChange($event)">
                                        <label class="form-check-label" for="flexCheckChecked">
                                            Intérim
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row">
                                            <div class="form-group col-md-6">
                                                <label for="tempWorker">Être intérimaire ? <span
                                                        class="star-style"></span></label>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <input type="radio" id="tempWorkerYes"
                                                            [checked]="(this.tempWorkerValue == true)" name="tempWorker">
                                                        <label for="tempWorkerYes" style="margin-left: 5px"> OUI</label>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <input type="radio" id="tempWorkerNo"
                                                            [checked]="(this.tempWorkerValue == false)" name="tempWorker">
                                                        <label for="tempWorkerNo" style="margin-left: 5px"> NON</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="driveLicence">Permis de conduire</label>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <input type="radio" id="driveLicenceYes"
                                                            [checked]="(this.driverLicenceValue == true)" name="driverLicence">
                                                        <label for="driveLicenceYes" style="margin-left: 5px"> OUI</label>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <input type="radio" id="driveLicenceNo"
                                                            [checked]="(this.driverLicenceValue == false)" name="driverLicence">
                                                        <label for="driveLicenceNo" style="margin-left: 5px"> NON</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="passport">Passport valide</label>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <input type="radio" id="passportYes"
                                                            [checked]="(this.passportValue == true)" name="passport">
                                                        <label for="passportYes" style="margin-left: 5px"> OUI</label>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <input type="radio" id="passportNo"
                                                            [checked]="(this.passportValue == false)" name="passport">
                                                        <label for="passportNo" style="margin-left: 5px"> NON</label>
                                                    </div>
                                                </div>
                                            </div>
        
                                        </div> -->
                            <button type="submit" class="primary-btn text-white" [disabled]="personalInfoForm.invalid"
                                *ngIf="!personalInfoIsLoading">SAUVEGARDER
                            </button>
                            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                *ngIf="personalInfoIsLoading">
                                Veuillez patienter...</p>
                        </form>

                        <form [formGroup]="profilesForm" (ngSubmit)="onSubmitProfileForm()">
                            <h3 class="mt-5 mb-3" style="text-align: center; font-weight: bold;">
                                Professions/Compétences
                            </h3>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="profession">Professions/Compétences <span
                                            class="star-style">**</span></label>
                                    <select class="form-control" id="profession" formControlName="profession_id">
                                        <option value="">Selectionner...</option>
                                        <option value="{{ profession.getId() }}"
                                            *ngFor="let profession of professionList">{{
                                            profession.getLibelle() }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <button style="margin-top: 35px;" type="submit" class="primary-btn text-white"
                                        [disabled]="profilesForm.invalid" *ngIf="!profileIsLoading">SAUVEGARDER</button>
                                    <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                        *ngIf="profileIsLoading">
                                        Veuillez patienter...</p>
                                </div>
                            </div>
                        </form>

                        <div class="form-group" style="width: 100%; overflow: auto;">
                            <table class="table table-bordered">
                                <tr>
                                    <th>Profiles</th>
                                    <th>Action</th>
                                </tr>
                                <tr *ngFor="let candidateProfile of candidateProfileList">
                                    <td>{{ candidateProfile.getProfessions()['libelle'] }}</td>
                                    <td><span class="btn btn-danger">Supp</span>
                                    </td>
                                </tr>
                            </table>
                        </div>


                        <div class="row justify-content-center mt-5">
                            <!-- Button to go back apply job -->
                            <button *ngIf="showBtnToGoApplyJob" routerLink="/postuler/{{ jobIDToApply }}"
                                class="btn btn-warning mr-2">Retour vers l'offre</button>

                            <button class="btn btn-primary col-md-6" routerLink="/candidat-trainings"> Cliquez ici
                                pour
                                ajouter
                                vos formations et diplômes
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-articles></app-articles>
            </div>
        </div>
        <!-- <section class="row justify-content-center">
            <div class="col-md-4 mb-3" *ngIf="showBtnToGoApplyJob">
                <button routerLink="/postuler/{{ jobIDToApply }}" style="color: white;" class="btn btn-danger">Retour
                    vers l'offre</button>
            </div>
            <div class="row mb-5">
                <div class="col-md-9 ">
                    <div class="card"
                        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); padding: 50px;">
                        <div class="card-body">
                            <h3 class="mt-3 mb-5" style="text-align: center; font-weight: bold;">Informations
                                personnelles
                            </h3>

                            <form [formGroup]="personalInfoForm" (ngSubmit)="onSubmitPersonalInfoForm()">
                                <div style="margin-top: -5px; margin-bottom: 10px; color: red;">
                                    Cliquer sur le bouton <strong>"SAUVEGARDER"</strong> après avoir
                                    effectuée des
                                    modifications sur le formulaire.
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label for="gender">Sexe <span class="star-style">**</span></label>
                                        <select class="form-control" id="gender" formControlName="gender">
                                            <option value="Homme">Homme</option>
                                            <option value="Femme">Femme</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="maritalStatus">Situation matrimoniale</label>
                                        <select class="form-control" id="maritalStatus" formControlName="maritalStatus">
                                            <option value="célibataire">Célibataire</option>
                                            <option value="Marié(e) avec enfant">Marié(e) avec enfants</option>
                                            <option value="Marié(e) sans enfant">Marié(e) sans enfants</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="lastName">Nom <span class="star-style">**</span></label>
                                        <input type="text" class="form-control h-40px" id="lastName"
                                            formControlName="lastName">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="firstName">Prénom <span class="star-style">**</span></label>
                                        <input type="text" class="form-control h-40px" id="firstName"
                                            formControlName="firstName">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label for="dateBirth">Date de naissance <span
                                                class="star-style">**</span></label>
                                        <input type="date" class="form-control h-40px" id="dateBirth"
                                            formControlName="dateBirth">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="email">Email <span class="star-style">**</span></label>
                                        <input type="hidden" class="form-control h-40px" formControlName="email">
                                        <input type="email" class="form-control h-40px" id="email"
                                            [value]="candidates.getEmail()" disabled>
                                    </div>

                                    <div class="form-group col-md-4"
                                        [ngClass]="idcardValue == null ? 'form-group col-md-6' : 'form-group col-md-4'">
                                        <label for="idcard">CNI/Passport<span
                                                style="font-size: 10px; font-weight: 700;">(pdf, < 1Mo)</span>
                                                    <span class="star-style">**</span></label>
                                        <span class="btn btn-success w-100" *ngIf="idcardValue == null"
                                            (click)="chooseNewIdcard()">Joindre
                                            CNI/passport</span>
                                        <span class="btn btn-primary w-100" *ngIf="idcardValue != null"
                                            (click)="chooseNewIdcard()">Remplacer
                                            CNI/passport</span>
                                        <span *ngIf="idcardFile != null"
                                            style="font-size: 10px; font-weight: 700; color: green">
                                            Super!
                                            Fichier
                                            joint</span>
                                    </div>
                                    <div class="form-group col-md-4 my-auto pt-3">
                                        <a [href]="idCard" target="_blank" class="btn btn-danger w-100"
                                            *ngIf="idcardValue !== null">Afficher
                                            CNI/passport</a>
                                    </div>

                                    <div class="form-group col-md-4"
                                        [ngClass]="cvValue == null ? 'form-group col-md-6' : 'form-group col-md-4'">
                                        <label for="curriculumVitae">Curriculum vitae <span
                                                style="font-size: 10px; font-weight: 700;">(pdf,
                                                < 1Mo)</span> <span class="star-style">**</span></label>
                                        <span class="btn btn-success w-100" *ngIf="cvValue == null"
                                            (click)="chooseNewCV()">Joindre
                                            curriculum
                                            vitae</span>
                                        <span class="btn btn-primary w-100" *ngIf="cvValue != null"
                                            (click)="chooseNewCV()">Remplacer
                                            CV</span>
                                        <span *ngIf="cvFile != null"
                                            style="font-size: 10px; font-weight: 700; color: green">
                                            Super!
                                            Fichier
                                            joint</span>
                                    </div>
                                    <div class="form-group col-md-4 my-auto pt-3">
                                        <a [href]="cvPath" target="_blank" class="btn btn-danger w-100"
                                            *ngIf="cvValue != null">Afficher
                                            CV</a>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label for="phone1">Téléphone 1 <span class="star-style">**</span></label>
                                        <input type="text" class="form-control h-40px" id="phone1"
                                            formControlName="phone1">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="phone2">Téléphone 2</label>
                                        <input type="text" class="form-control h-40px" id="phone2"
                                            formControlName="phone2">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label for="country">Pays</label>
                                        <select class="form-control" id="country" formControlName="country"
                                            (ngModelChange)="onChangeCountry($event)">
                                            <option [value]="country" *ngFor="let country of countryList">{{ country
                                                }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="city">Ville</label>
                                        <select class="form-control" id="city" formControlName="city">
                                            <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="tempWorker">Emploi recherché: <span
                                                class="star-style"></span></label>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="Emploi"
                                                id="flexCheckDefault" (change)="onCheckboxProfilChange($event)">
                                            <label class="form-check-label" for="flexCheckDefault">
                                                Emploi
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="Intérim"
                                                id="flexCheckChecked" (change)="onCheckboxProfilChange($event)">
                                            <label class="form-check-label" for="flexCheckChecked">
                                                Intérim
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            
                                <button type="submit" class="primary-btn text-white"
                                    [disabled]="personalInfoForm.invalid" *ngIf="!personalInfoIsLoading">SAUVEGARDER
                                </button>
                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                    *ngIf="personalInfoIsLoading">
                                    Veuillez patienter...</p>
                            </form>

                            <form [formGroup]="profilesForm" (ngSubmit)="onSubmitProfileForm()">
                                <h3 class="mt-5 mb-3" style="text-align: center; font-weight: bold;">
                                    Professions/Compétences
                                </h3>
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="profession">Professions/Compétences <span
                                                class="star-style">**</span></label>
                                        <select class="form-control" id="profession" formControlName="profession_id">
                                            <option value="">Selectionner...</option>
                                            <option value="{{ profession.getId() }}"
                                                *ngFor="let profession of professionList">{{
                                                profession.getLibelle() }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <button style="margin-top: 35px;" type="submit" class="primary-btn text-white"
                                            [disabled]="profilesForm.invalid"
                                            *ngIf="!profileIsLoading">SAUVEGARDER</button>
                                        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                            *ngIf="profileIsLoading">
                                            Veuillez patienter...</p>
                                    </div>
                                </div>
                            </form>

                            <div class="form-group" style="width: 100%; overflow: auto;">
                                <table class="table table-bordered">
                                    <tr>
                                        <th>Profiles</th>
                                        <th>Action</th>
                                    </tr>
                                    <tr *ngFor="let candidateProfile of candidateProfileList">
                                        <td>{{ candidateProfile.getProfessions()['libelle'] }}</td>
                                        <td><span class="btn btn-danger">Supp</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>


                            <div class="row justify-content-center mt-5">
                             
                                <button *ngIf="showBtnToGoApplyJob" routerLink="/postuler/{{ jobIDToApply }}"
                                    class="btn btn-warning mr-2">Retour vers l'offre</button>

                                <button class="btn btn-primary col-md-6" routerLink="/candidat-trainings"> Cliquez ici
                                    pour
                                    ajouter
                                    vos formations et diplômes
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <app-articles></app-articles>
                </div>
            </div>
        </section> -->
    </div>
</section>